import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Formsy from 'formsy-react';
import { updateGiftCard, hideGiftCardModal } from '../giftCard.actions';
import translator from '../../../components/localization/translator';
import { Modal } from 'react-bootstrap';
import { GIFT_CARD_FIELDS } from './EditableFields';
import { GIFT_CARD_STATUSES } from '../../../config/constants';
import FormInput from '../../../components/common/elements/FormInput';
class GiftCardDetails extends Component {
    constructor(props) {
        super(props);
        this.changedData = {};
        this.state = {};
        this.initialState = {
            cardId: '',
            purchaseOrderId: '',
            initialBalance: 0,
            currentBalance: 0,
            name: '',
            phone: '',
            startDate: '',
            soldDate: '',
            activationDate: '',
            endDate: '',
        };
        this.cancel = this.cancel.bind(this);
        this.setChangedData = this.setChangedData.bind(this);
        this.renderEditableFields = this.renderEditableFields.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.giftCards.giftCard) {
            this.changedData = { ...nextProps.giftCards.giftCard };
        }
    }

    setChangedData(key, value) {
        this.changedData[key] = value;
    }

    getData() {
        const data = {};
        GIFT_CARD_FIELDS.giftCardFields().forEach((field) => {
            const key = field.name;
            data[key] = this.changedData[key];
        });
        return data;
    }

    cancel() {
        this.props.hideGiftCardModal();
        this.setState(this.initialState);
        this.changedData = {};
    }

    renderEditableFields(options, index) {
        let value = this.changedData[options.name];
        if ('date' === options.type) {
            if (this.changedData[options.name]) {
                value = moment(this.changedData[options.name]).format('DD/MM/YYYY HH:mm:ss');
            }
            options.type = 'text';
        }
        return (
            <FormInput
                {...options}
                inputType={options.inputType}
                id={options.name}
                key={index}
                value={value || (options.type === 'number' ? '0' : '')}
                disabled={options.disabled}
                onChange={(e) => {
                    this.setState({ [options.name]: e.target.value });
                    this.setChangedData(options.name, e.target.value)
                }}
            />
        );
    }

    renderOrdersHistory() {
        if (this.changedData && this.changedData.history) {
            const orders = this.changedData.history;
            return (
                <div className={'display-flex align-left'}>
                    <label className={'label-width'}>{translator.translate('_orders_')}</label>
                    <div>
                        {orders.map(order => {
                            return (
                                <div key={`${order.orderId}-${order.usedAmount}` } className={'order-container'}>
                                    <div>
                                        <div className={'gift-card-order-id'}>{order.orderNumber}</div>
                                        <span className={'order-date'}>{moment(order.orderDate).format('DD/MM/YYYY HH:mm:ss')}</span>
                                    </div>
                                    <div className={'used-price'}>
                                        <span >{ (order.usedAmount > 0 ? "" : "+") + (-1 * order.usedAmount)} ֏</span>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )
        }
    }

    getTitle(giftCard) {
        if (giftCard) {
            const { cardCode, status } = giftCard;
            return (
                <div>{cardCode}
                    <div className={`label label-${GIFT_CARD_STATUSES.statusById(Number(status)).style}`}
                        style={{ 'marginLeft': '10px' }}>
                        {translator.translate(GIFT_CARD_STATUSES.statusById(Number(status)).name || '')}
                    </div>
                </div>
            );
        } else {
            return translator.translate('_edit_gift_card_');
        }
    }

    render() {
        const giftCard = this.props.giftCards.giftCard;
        return (
            <Modal
                bsSize='large'
                show={this.props.giftCards.show}
                onHide={this.cancel.bind(this)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.getTitle(giftCard)}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className={'scrollable modal-possition'}>
                    <Formsy>
                        {GIFT_CARD_FIELDS.giftCardFields(this.state.status).map(this.renderEditableFields)}
                        {this.renderOrdersHistory()}
                    </Formsy>
                </Modal.Body>
            </Modal>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        giftCards: state.giftCards,
    };
};
export default connect(mapStateToProps, {
    updateGiftCard,
    hideGiftCardModal
})(GiftCardDetails);
